import React, { useRef, useContext, useState, useEffect } from 'react';
import log from 'loglevel';
import { Context, usePlayerContext } from '../Context';

interface Item {
  val: number;
  label: string;
}

interface SelectControlProps {
  items: Item[];
  controlSlug: string;
  handleAction: (playbackRate: any) => void;
  currentValue: number;
}

const SelectControl = ({
  items,
  currentValue,
  controlSlug,
  handleAction,
}: SelectControlProps) => {
  const { sdk } = usePlayerContext();

  const initCurrent = () => {
    //search items for currentValue
    const item = items.find((item) => item.val === currentValue);
    return item?.val;
  };

  const [current, setCurrent] = useState(initCurrent);

  const select = (val: any) => {
    setCurrent(val);
    handleAction(val);
  };

  useEffect(() => {
    setCurrent(initCurrent())
  }, [currentValue]);

  return (
    <>
      {items.map((item, index) => {
        return (
          <div
            className={`${sdk.getClassNamePrefix()}-player-control-menu-item ${sdk.getClassNamePrefix()}-player-${controlSlug}-menu-item ${item.val === current ? sdk.getClassNamePrefix() + '-player-control-menu-item-selected' : ''}`}
            key={index}
            onClick={() => {
              select(item.val);
            }}
            role="button"
            onKeyDown={() => {}}
            //tabIndex={index}
          >
            {item.label}
          </div>
        );
      })}
    </>
  );
};

export {
  Item
}

export default SelectControl;
